<template>
  <div class="rounded-lg border p-4 mb-6" :class="styleClasses">
    <div class="flex items-start gap-3">
      <span class="text-xl mt-0.5">{{ icon }}</span>
      <div>
        <h4 v-if="title" class="font-semibold mb-1" :class="titleClass">{{ title }}</h4>
        <MarkdownText :content="content" class="text-sm" />
      </div>
    </div>
  </div>
</template>

<script>
import { MarkdownText } from "@estaly/ui";

export default {
  name: "CalloutSection",
  components: { MarkdownText },
  props: {
    calloutStyle: { type: String, default: "info" },
    title: { type: String, default: "" },
    content: { type: String, required: true },
  },
  computed: {
    styleClasses() {
      const styles = {
        info: "bg-blue-50 border-blue-200",
        warning: "",
        tip: "bg-green-50 border-green-200",
      };
      return styles[this.calloutStyle] ?? styles.info;
    },
    titleClass() {
      const styles = {
        info: "text-blue-800",
        warning: "",
        tip: "text-green-800",
      };
      return styles[this.calloutStyle] ?? styles.info;
    },
    icon() {
      const icons = {
        info: "\u2139\uFE0F",
        warning: "\u26A0\uFE0F",
        tip: "\uD83D\uDCA1",
      };
      return icons[this.calloutStyle] || "\u2139\uFE0F";
    },
  },
};
</script>
